import React, { useEffect } from 'react';

const getBackendOrigin = () => {
  if (window.location.hostname === 'localhost' && window.location.port === '3000') {
    return `${window.location.protocol}//${window.location.hostname}:3001`;
  }

  return window.location.origin;
};

const Unsubscribe = () => {
  useEffect(() => {
    const targetUrl = `${getBackendOrigin()}/api/marketing${window.location.pathname}${window.location.search}`;
    window.location.replace(targetUrl);
  }, []);

  return (
    <div className="bg">
      <section className="mx-5">
        <div className="vh-100">
          <div className="row h-100 justify-content-center align-items-center">
            <div className="col-12 text-center">
              <h1 className="mb-3">Processing your unsubscribe request...</h1>
              <p className="text-muted">
                If you are not redirected automatically, refresh the page and try again.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Unsubscribe;
